import common from './common';
import main from './main';

const en = { common, main };
export default en;
